import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as ErrorProvider, ErrorBoundary } from '@rollbar/react';
import { Provider as StateProvider } from 'react-redux';
import { StytchProvider } from '@stytch/react';
import { StytchUIClient } from '@stytch/vanilla-js';
import { store } from './store';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

if (!process.env.REACT_APP_STYTCH_PUBLIC_TOKEN) {
  throw new Error('Missing REACT_APP_STYTCH_PUBLIC_TOKEN environment variable');
}

// Initialize Stytch client with cookie options
const stytchClient = new StytchUIClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN, {
  cookieOptions: {
    opaqueTokenCookieName: 'stytch_session',
    jwtCookieName: 'stytch_session_jwt',
    path: '/',
    availableToSubdomains: false,
    domain: '',
  },
});

const rollbarConfig =
  process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN && process.env.REACT_APP_ENVIRONMENT
    ? {
        accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
        environment: process.env.REACT_APP_ENVIRONMENT,
        captureUncaught: true,
        captureUnhandledRejections: true,
      }
    : {
        enabled: false,
      };

if (process.env.NODE_ENV === 'production') {
  if (typeof (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
    for (const [key, value] of Object.entries((window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__[key] =
        typeof value === 'function' ? () => {} : null;
    }
  }
}

if (process.env.REACT_APP_AMPLITUDE_API_KEY) {
  amplitude.add(sessionReplayPlugin({ sampleRate: 0.5 }));
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <StateProvider store={store}>
      <ErrorProvider config={rollbarConfig}>
        <ErrorBoundary>
          <StytchProvider stytch={stytchClient}>
            <App />
          </StytchProvider>
        </ErrorBoundary>
      </ErrorProvider>
    </StateProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
